import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {getCustomFieldsFilters, getIntersectedCPSelection, getTaskCustomFieldsMap, getTaskNameFilter, getTaskStatusFilter, isShowOnlyManageableTasks} from '../common/selectors'
import {getShownColumnsWithOrderForCsv, getSummaryRow, getTasksSorting} from '../tasksTable/selectors'
import {convertTaskListAndSaveAsCsv} from './utils'
import {afterTaskListExportRequestFailed} from '../syncCallbacks'
import {isTWSEnabled} from '../../features/selectors'
import {makeLoadTasksRequest} from '../tasksTable/connector'
import { getIsSummaryRowShown } from './selectors'

const setExportInProgress = createAction(ActionTypes.CSV_EXPORT_IN_PROGRESS_SET)

export const exportTaskListCsv = () => (dispatch, getState) => {
    dispatch(setExportInProgress(true))
    const state = getState()
    const columnsWithOrder = getShownColumnsWithOrderForCsv(state)
    const taskCustomFields = getTaskCustomFieldsMap(state)
    makeLoadTasksRequest({
        intersectedCPSelection: getIntersectedCPSelection(state),
        taskStatusFilter: getTaskStatusFilter(state),
        customFieldsFilters: getCustomFieldsFilters(state),
        taskNameFilter: getTaskNameFilter(state),
        showOnlyManageableTasks: isShowOnlyManageableTasks(state),
        taskSorting: getTasksSorting(state),
        offset: 0,
        noRetry: true
    }).then((data) => {
        const summaryRow = getIsSummaryRowShown(state) && getSummaryRow(state)

        convertTaskListAndSaveAsCsv(data, columnsWithOrder, taskCustomFields, isTWSEnabled(state), summaryRow)
        dispatch(setExportInProgress(false))
    })
      .catch((err) => {
          dispatch(setExportInProgress(false))
          afterTaskListExportRequestFailed(err)
      })
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/actions.js